// extracted by mini-css-extract-plugin
module.exports = {"news":"news_news__3Ifc-","newsImg":"news_newsImg__2HKX2","newsHeader":"news_newsHeader__3Gnd2","newsBody":"news_newsBody__4msST"};